import { Discount } from "./discount";

export class ProductCart {
    code: number;
    productCode: string;
    description: string;
    tax: number;
    taxCode: string;
    originalTaxCode: string;
    price: number;
    total: number;
    serial: string;
    amount: number;
    returnedAmount: number;
    requiredSerial: boolean;
    discount: Discount;
    discount2: Discount;
    discountTotal: number;
    taxTotal: number;
    referenceCode: number;
    applyDelivery?: boolean;
    isDelivery: boolean;
    deliveryBranchCode: string;
    hasWarranty: boolean;
    features: { [value: string]: string };
    hasExtraWarrantyAdded: boolean;
    comboSetCode: string;
    associatedOrder: string;
    associatedOrderEntry: string;
    associatedSerialNumber: string;
    extraWarrantyInvoiceCode: string;
    extraWarrantyInvoiceLine: string;
    stock: number;
    isService: boolean;
    comboProduct: string;
    wharehouseNumber: string;
    wharehouseLocation: string;
    inputMarkForChecked: boolean;
    inputCheckedAmount: number;
    checkedAmount: number;
    // downPayment: number;
    // term: number;
    // rate: number;
    inputMarkForReturn: boolean;
    inputReturnedAmount: number;
    constructor() {
        this.code = 0;
        this.productCode = "";
        this.description = "";
        this.tax = 0.0;
        this.price = 0.0;
        this.total = 0.0;
        this.serial = "";
        this.amount = 0;
        this.returnedAmount = 0;
        this.taxCode = "";
        this.originalTaxCode = "";
        this.requiredSerial = false;
        this.discount = new Discount();
        this.discount2 = new Discount();
        this.discountTotal = 0;
        this.taxTotal = 0;
        this.referenceCode = 0;
        this.applyDelivery = false;
        this.isDelivery = false;
        this.deliveryBranchCode = "";
        this.hasWarranty = false;
        this.features = {};
        this.hasExtraWarrantyAdded = false;
        this.comboSetCode = '';
        this.comboProduct = "";
        this.associatedOrder = "";
        this.associatedOrderEntry = "";
        this.extraWarrantyInvoiceCode = "";
        this.extraWarrantyInvoiceLine = "";
        this.associatedSerialNumber = '';
        this.stock = 0;
        this.inputMarkForReturn = false;
        this.inputReturnedAmount = 0;
        this.isService = false;
        this.wharehouseLocation = "";
        this.wharehouseNumber = "";
        this.inputMarkForChecked = false;
        this.inputCheckedAmount = 0;
        this.checkedAmount = 0;
    }

    setCode(code: number): ProductCart {
        this.code = code;
        return this;
    }

    setProductCode(productCode: string): ProductCart {
        this.productCode = productCode;
        return this;
    }

    setDescription(description: string): ProductCart {
        this.description = description;
        return this;
    }

    setTax(tax: number): ProductCart {
        this.tax = tax;
        return this;
    }

    setPrice(precio: number): ProductCart {
        this.price = precio;
        return this;
    }

    setTotal(total: number): ProductCart {
        this.total = total;
        return this;
    }

    setSerial(serial: string): ProductCart {
        this.serial = serial;
        return this;
    }

    setApplyDelivery(applyDelivery: boolean) {
        this.applyDelivery = applyDelivery;
        return this;
    }

    setAmount(amount: number): ProductCart {
        this.amount = amount;
        return this;
    }

    setTaxCode(taxCode: string): ProductCart {
        this.taxCode = taxCode;
        return this;
    }

    setOriginalTaxCode(originalTaxCode: string): ProductCart {
        this.originalTaxCode = originalTaxCode;
        return this;
    }
    setRequiredSerial(requiredSerial: boolean) {
        this.requiredSerial = requiredSerial;
        return this;
    }

    setDiscount(discount: Discount) {
        this.discount = discount;
        return this;
    }

    setDiscount2(discount: Discount) {
        this.discount2 = discount;
        return this;
    }

    setDiscountTotal(discountValue: number) {
        this.discountTotal = discountValue;
        return this;
    }

    setTaxTotal(taxTotal: number) {
        this.taxTotal = taxTotal;
        return this;
    }

    setReferenceCode(referencCode: number): ProductCart {
        this.referenceCode = referencCode;
        return this;
    }

    setIsDelivery(isDelivery: boolean) {
        this.isDelivery = isDelivery;
        return this;
    }
    setDeliveryBranchCode(deliveryBranchCode: string) {
        this.deliveryBranchCode = deliveryBranchCode;
        return this;
    }
    setHasWarranty(hasWarranty: boolean) {
        this.hasWarranty = hasWarranty;
        return this;
    }

    setFeatures(features: { [value: string]: string }) {
        this.features = features;
        return this;
    }

    setHasExtraWarrantyAdded(hasExtraWarrantyAdded: boolean) {
        this.hasExtraWarrantyAdded = hasExtraWarrantyAdded;
        return this;
    }

    setComboSetCode(comboSetCode: string) {
        this.comboSetCode = comboSetCode;
        return this;
    }

    setAssociatedOrderEntry(associatedOrderEntry: string) {
        this.associatedOrderEntry = associatedOrderEntry;
        return this;
    }

    setAssociatedOrder(associatedOrder: string) {
        this.associatedOrder = associatedOrder;
        return this;
    }

    setExtraWarrantyInvoiceCode(extraWarrantyInvoiceCode: string) {
        this.extraWarrantyInvoiceCode = extraWarrantyInvoiceCode;
        return this;
    }

    setExtraWarrantyInvoiceLine(extraWarrantyInvoiceLine: string) {
        this.extraWarrantyInvoiceLine = extraWarrantyInvoiceLine;
        return this;
    }

    setAssociatedSerialNumber(associatedSerialNumber: string) {
        this.associatedSerialNumber = associatedSerialNumber;
        return this;
    }

    setIsService(isService: boolean) {
        this.isService = isService;
        return this;
    }

    setComboProduct(comboProduct: string) {
        this.comboProduct = comboProduct;
        return this;
    }

    setWharehouseNumber(wharehouseNumber: string) {
        this.wharehouseNumber = wharehouseNumber;
        return this;
    }

    setWharehouseLocation(wharehouseLocation: string) {
        this.wharehouseLocation = wharehouseLocation;
        return this;
    }
}
